import React from 'react';
import {Title, Video, Paragraph} from './../../Basics';
import Particle from './../../Particle'; //eslint-disable-line no-unused-vars

const Particle26 = () => (<div>

  <Title>Greifen mit einer Armprothese</Title>

  <Paragraph>
    Der Österreicher Patrick Mayrhofer hat am Cybathlon die Silbermedaille
    im Armprothesen-Parcours gewonnen. Im Film erklärt er, wie seine Hightech-Prothese
    Modell Michelangelo funktioniert.
  </Paragraph>

  <Video
    source={require('./Interview_Patrick_Mayrhofer.mp4')}
    poster={require('./P26_preview.png')}
  />

  <Particle
    number={12}
  />

</div>);

export default Particle26;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle26/Particle26.js
 **/